import React from "react";
import { bemClassesFromModifiers } from "../../constants/misc";

const MoveBoxAppBar = (props) => {
  const { children, absolute } = props;
  return (
    <div
      className={bemClassesFromModifiers("moveBox__appBar", [
        absolute ? "absolute" : null,
      ])}
    >
      {children}
    </div>
  );
};

export default MoveBoxAppBar;
